<template>
  <div id="not-found" class="text-center d-flex justify-content-center align-items-center h-100">
    <div>
      <h1>
        <i class="ti ti-fw ti-2x ti-warning" /><br>
        {{ $t(`error.${code}.title`) }}
      </h1>
      <p>{{ $t(`error.${code}.message`) }}</p>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ErrorView',
    props: {
      code: {
        type: String,
        default: '0',
      },
    },
    computed: {
      pcieUrl() {
        return this.get().parameters.monpcie.value;
      },
    },
  };
</script>

<style lang="scss" scoped>
h1 {
  color: map-get($grays, '700' );
  font-weight: bold;
  font-size: 1.4rem;
  text-transform: uppercase;
}
</style>
